import noScroll from 'no-scroll'
import useScrollbarSize from 'react-scrollbar-size'

export const useHeaderScroll = (idWidthNode: string) => {
  const { width } = useScrollbarSize()
  const setWidthNode = (state: boolean) => {
    ;(document.getElementById(idWidthNode) as HTMLElement).style.width = state ? `calc(100% - ${width}px)` : `100%`
  }

  const setScroll = (state: boolean) => {
    // true = stop scroll
    if (state) {
      noScroll.on()
      return setWidthNode(true)
    }
    noScroll.off()
    setWidthNode(false)
  }
  return { setScroll }
}
